module.exports = __webpack_public_path__ + "static/media/orare.d7a783f4.jpg";